<script lang="ts">
  import globalStore from '@/stores/global.svelte'
  import keywordsStore from '@/stores/keywords.svelte'

  let {
    keyword = {},
  } = $props()

  let currentAccount = $derived(globalStore.currentAccount)
  let not = $derived(currentAccount.skip_opt_ins ? '' : 'NOT')

  function onchange(evt) {
    const val = evt.target.checked

    keywordsStore.updateKeyword({
      id: keyword.to_param,
      params: {
        keyword: {
          skip_opt_ins: val
        }
      }
    })
  }
</script>

<div class="panel shaded">
  <div>
    Skip opt-ins?
  </div>
  <div class="help-block">
    Account is {not} skipping opt-ins.
  </div>
  <label class="block mt-1">
    <input
      type="checkbox"
      class="switch-checkbox"
      checked={keyword.skip_opt_ins}
      disabled={currentAccount.skip_opt_ins}
      {onchange}
    />
    <span class="switch"></span>
  </label>
</div>
